var _regeneratorRuntime = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/createClass");

(function () {
  if (typeof global !== "undefined") {// global already exists
  } else if (typeof window !== "undefined") {
    window.global = window;
  } else if (typeof self !== "undefined") {
    self.global = self;
  } else {
    throw new Error("cannot export (neither global, window nor self is defined)");
  }

  global.Server =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class(address) {
      _classCallCheck(this, _class);

      this.address = address;
    }

    _createClass(_class, [{
      key: "get_manifest_by_doi",
      value: function () {
        var _get_manifest_by_doi = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(doi) {
          var result, url, response, json_data;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  result = {
                    status: "",
                    data: null
                  };
                  url = this.address + '/manifest/' + doi;
                  _context.prev = 2;
                  _context.next = 5;
                  return fetch(url);

                case 5:
                  response = _context.sent;
                  _context.prev = 6;

                  if (!(200 === response.status)) {
                    _context.next = 15;
                    break;
                  }

                  _context.next = 10;
                  return response.json();

                case 10:
                  json_data = _context.sent;
                  result.data = json_data;
                  result.status = "ok";
                  _context.next = 16;
                  break;

                case 15:
                  result.status = "Response error: " + response.statusText;

                case 16:
                  _context.next = 21;
                  break;

                case 18:
                  _context.prev = 18;
                  _context.t0 = _context["catch"](6);
                  result.status = "Error parsing request (" + _context.t0 + ")";

                case 21:
                  _context.next = 26;
                  break;

                case 23:
                  _context.prev = 23;
                  _context.t1 = _context["catch"](2);
                  result.status = "Error requesting server (" + _context.t1 + ")";

                case 26:
                  return _context.abrupt("return", result);

                case 27:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[2, 23], [6, 18]]);
        }));

        function get_manifest_by_doi(_x) {
          return _get_manifest_by_doi.apply(this, arguments);
        }

        return get_manifest_by_doi;
      }()
    }, {
      key: "get_data_by_doi",
      value: function () {
        var _get_data_by_doi = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(doi) {
          var result, url, response, raw_data;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  result = {
                    status: "",
                    data: null
                  };
                  url = this.address + '/rawdata/' + doi;
                  _context2.prev = 2;
                  _context2.next = 5;
                  return fetch(url);

                case 5:
                  response = _context2.sent;

                  if (!(200 === response.status)) {
                    _context2.next = 14;
                    break;
                  }

                  _context2.next = 9;
                  return response.arrayBuffer();

                case 9:
                  raw_data = _context2.sent;
                  result.data = raw_data;
                  result.status = "ok";
                  _context2.next = 15;
                  break;

                case 14:
                  result.status = "Response error: " + response.statusText;

                case 15:
                  _context2.next = 20;
                  break;

                case 17:
                  _context2.prev = 17;
                  _context2.t0 = _context2["catch"](2);
                  result.status = "Error requesting server (" + _context2.t0 + ")";

                case 20:
                  return _context2.abrupt("return", result);

                case 21:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[2, 17]]);
        }));

        function get_data_by_doi(_x2) {
          return _get_data_by_doi.apply(this, arguments);
        }

        return get_data_by_doi;
      }()
    }]);

    return _class;
  }();
})();